import { render } from "./goal-type-modal.vue?vue&type=template&id=7b033063"
import script from "./goal-type-modal.vue?vue&type=script&lang=js"
export * from "./goal-type-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__